const HeroSection = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="pt-24 lg:pt-32 pb-16 lg:pb-24 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Content - 7 cols */}
          <div className="lg:col-span-7 space-y-6">
            <h1
              data-testid="hero-heading"
              className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-[#0F172A] leading-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Expert <span className="text-[#06B6D4]">CAD/CAM</span> Software Development Services & Engineering Solutions
            </h1>
            
            <p
              data-testid="hero-subtext"
              className="text-lg text-[#0F172A]/70 leading-relaxed max-w-xl"
            >
              Certified SolidWorks API & NXOpen specialists with 15+ years of expertise. We develop enterprise plugins, automation tools, and custom solutions for many US and Europe MNCs. Expert in SolidWorks API, NXOpen, devDept Eyeshot, AutoCAD .NET, and CAD automation using C#, C++, Python, and VB.NET.
            </p>
          </div>

          {/* Right Content - 5 cols */}
          <div className="lg:col-span-5">
            <div className="relative">
              <img
                src="https://static.prod-images.emergentagent.com/jobs/8efe3dd2-f765-4cc0-8549-c94d2b68134a/images/504d90c23d34bd6adcf0f7c0251ca82bcc20b312a15e7ab1283eb5a07daf4212.png"
                alt="CAD Design Illustration"
                data-testid="hero-image"
                className="hero-image w-full h-auto rounded-3xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
